import { render, staticRenderFns } from "./IndustrialMovimantationDetail.vue?vue&type=template&id=06552174"
import script from "./IndustrialMovimantationDetail.vue?vue&type=script&lang=js"
export * from "./IndustrialMovimantationDetail.vue?vue&type=script&lang=js"
import style0 from "./IndustrialMovimantationDetail.vue?vue&type=style&index=0&id=06552174&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports